import { UseContextsCategory } from "#competence/contexts/ContextsCategory"
import { CategoryGet } from "#competence/services/Api"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import AddIcon from "@mui/icons-material/Add"
import { Button, Skeleton } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"
import MUIDataTable from "mui-datatables"
import ChipStatus from "../ChipStatus"

export default function CategoryTable() {
	ChangeTitle("Categoría")
	const { reload, setOpenForm, setCategory, setOpenInfo } = UseContextsCategory()

	const { data, error, loading } = useApi(CategoryGet, { autoFetch: true, reload })

	const columns = [
		{
			name: "name",
			label: "Nombre",
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: "description",
			label: "Descripción",
			options: {
				filter: true,
				sort: false,
			},
		},
		{
			name: "active",
			label: "Activo",
			options: {
				filter: true,
				sort: false,
				customBodyRender: (value, tableMeta) => {
					return <ChipStatus active={value} />
				},
			},
		},
	]
	const onRowClick = (rowData, { dataIndex }) => {
		const dataSelect = data?.data[dataIndex] || {}
		setCategory(dataSelect)
		setOpenInfo(true)
	}
	const options = {
		filter: false,
		download: false,
		print: false,
		viewColumns: false,
		selectableRows: "none",
		onRowClick,
		textLabels: {
			body: {
				noMatch: "No hay Categorías", // Cambia este mensaje
			},
		},

		customToolbar: () => (
			<Button color="primary" startIcon={<AddIcon />} onClick={() => setOpenForm(true)}>
				Agregar Categoría
			</Button>
		),
	}

	if (loading) return <Skeleton height={"80vh"} width={"100%"} />
	if (error) return <ErrorResponse />

	return (
		<MUIDataTable
			title={"Categoría"}
			data={data?.data || []}
			columns={columns}
			options={options}
		/>
	)
}
